import { default as _91_46_46_46slug_93nOvtUlSUXJMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/[...slug].vue?macro=true";
import { default as leftbarmVuEM5K8lBMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/[user_id]/components/leftbar.vue?macro=true";
import { default as mid_45tabbarKJLGhQnWDzMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/[user_id]/components/mid-tabbar.vue?macro=true";
import { default as right_45info3XKWBgl5q7Meta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/[user_id]/components/right-info.vue?macro=true";
import { default as top_45bannerHKIdgqWaZLMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/[user_id]/components/top-banner.vue?macro=true";
import { default as homeuQRCG7YvQ8Meta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/[user_id]/home.vue?macro=true";
import { default as indexRArobatj8uMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/404/index.vue?macro=true";
import { default as googleGkoQL09CKYMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/account/google.vue?macro=true";
import { default as loginpE95yNRaP1Meta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/account/login.vue?macro=true";
import { default as passwordu1YNS3QhLyMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/account/password.vue?macro=true";
import { default as registerMBLr1pn6l9Meta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/account/register.vue?macro=true";
import { default as _91articleId_93Nm2uCYIGLdMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/article/[articleId].vue?macro=true";
import { default as import_45modelePJTVFUYeJMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/carry/import-model.vue?macro=true";
import { default as ling_45accountsWtcHRws8KZMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/carry/ling-accounts.vue?macro=true";
import { default as select_45modelmCWOXkC6FgMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/carry/select-model.vue?macro=true";
import { default as _91model_id_93hQb6cZDgwTMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/claim/[model_id].vue?macro=true";
import { default as _91id_93qipLBRdxc2Meta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/collection/[id].vue?macro=true";
import { default as _91model_id_93KSN6OuzVMyMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/editUpload/[model_id].vue?macro=true";
import { default as _91setting_id_93Z6OLEfqMRmMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/editUploadPrintConf/[setting_id].vue?macro=true";
import { default as indexwQyLDfucO1Meta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/homepage/index.vue?macro=true";
import { default as indexVt9EaNmzPbMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/index.vue?macro=true";
import { default as redemption_45storeHFoRFgTcnpMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/integralSystem/redemption-store.vue?macro=true";
import { default as reward_45tasksgVGyJui6LFMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/integralSystem/reward-tasks.vue?macro=true";
import { default as transaction_45details0d338T6JmpMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/integralSystem/transaction-details.vue?macro=true";
import { default as following_45feedq6bFsX8jeNMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/messages/following-feed.vue?macro=true";
import { default as notifications_45preferences16klhIIRc4Meta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/messages/notifications-preferences.vue?macro=true";
import { default as replies_45mentionsqZ4gbYUxD0Meta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/messages/replies-mentions.vue?macro=true";
import { default as system_45notificationsM7D5wXw8OEMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/messages/system-notifications.vue?macro=true";
import { default as _91model_id_93pUNUxZmUYKMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/models/[model_id].vue?macro=true";
import { default as indexDottY4wqy9Meta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/models/index.vue?macro=true";
import { default as _91model_id_93qT49N82JMEMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/models/third-party/[model_id].vue?macro=true";
import { default as collectionsj5k5JjEntMMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/search/collections.vue?macro=true";
import { default as creatorsHVtxigTIATMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/search/creators.vue?macro=true";
import { default as works66GbGZo9dFMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/search/works.vue?macro=true";
import { default as _91pathName_937KKRD7AWFsMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/terms/[pathName].vue?macro=true";
import { default as indexsYkUOICUYJMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/upload/index.vue?macro=true";
import { default as _91model_id_937i9hPvjmUPMeta } from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/uploadPrintConf/[model_id].vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/[...slug].vue")
  },
  {
    name: "user_id-components-leftbar",
    path: "/:user_id()/components/leftbar",
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/[user_id]/components/leftbar.vue")
  },
  {
    name: "user_id-components-mid-tabbar",
    path: "/:user_id()/components/mid-tabbar",
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/[user_id]/components/mid-tabbar.vue")
  },
  {
    name: "user_id-components-right-info",
    path: "/:user_id()/components/right-info",
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/[user_id]/components/right-info.vue")
  },
  {
    name: "user_id-components-top-banner",
    path: "/:user_id()/components/top-banner",
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/[user_id]/components/top-banner.vue")
  },
  {
    name: "user_id-home",
    path: "/:user_id()/home",
    meta: homeuQRCG7YvQ8Meta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/[user_id]/home.vue")
  },
  {
    name: "404",
    path: "/404",
    meta: indexRArobatj8uMeta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/404/index.vue")
  },
  {
    name: "account-google",
    path: "/account/google",
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/account/google.vue")
  },
  {
    name: "account-login",
    path: "/account/login",
    meta: loginpE95yNRaP1Meta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/account/login.vue")
  },
  {
    name: "account-password",
    path: "/account/password",
    meta: passwordu1YNS3QhLyMeta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/account/password.vue")
  },
  {
    name: "account-register",
    path: "/account/register",
    meta: registerMBLr1pn6l9Meta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/account/register.vue")
  },
  {
    name: "article-articleId",
    path: "/article/:articleId()",
    meta: _91articleId_93Nm2uCYIGLdMeta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/article/[articleId].vue")
  },
  {
    name: "carry-import-model",
    path: "/carry/import-model",
    meta: import_45modelePJTVFUYeJMeta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/carry/import-model.vue")
  },
  {
    name: "carry-ling-accounts",
    path: "/carry/ling-accounts",
    meta: ling_45accountsWtcHRws8KZMeta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/carry/ling-accounts.vue")
  },
  {
    name: "carry-select-model",
    path: "/carry/select-model",
    meta: select_45modelmCWOXkC6FgMeta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/carry/select-model.vue")
  },
  {
    name: "claim-model_id",
    path: "/claim/:model_id()",
    meta: _91model_id_93hQb6cZDgwTMeta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/claim/[model_id].vue")
  },
  {
    name: "collection-id",
    path: "/collection/:id()",
    meta: _91id_93qipLBRdxc2Meta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/collection/[id].vue")
  },
  {
    name: "editUpload-model_id",
    path: "/editUpload/:model_id()",
    meta: _91model_id_93KSN6OuzVMyMeta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/editUpload/[model_id].vue")
  },
  {
    name: "editUploadPrintConf-setting_id",
    path: "/editUploadPrintConf/:setting_id()",
    meta: _91setting_id_93Z6OLEfqMRmMeta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/editUploadPrintConf/[setting_id].vue")
  },
  {
    name: "homepage",
    path: "/homepage",
    meta: indexwQyLDfucO1Meta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/homepage/index.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexVt9EaNmzPbMeta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/index.vue")
  },
  {
    name: "integralSystem-redemption-store",
    path: "/integralSystem/redemption-store",
    meta: redemption_45storeHFoRFgTcnpMeta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/integralSystem/redemption-store.vue")
  },
  {
    name: "integralSystem-reward-tasks",
    path: "/integralSystem/reward-tasks",
    meta: reward_45tasksgVGyJui6LFMeta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/integralSystem/reward-tasks.vue")
  },
  {
    name: "integralSystem-transaction-details",
    path: "/integralSystem/transaction-details",
    meta: transaction_45details0d338T6JmpMeta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/integralSystem/transaction-details.vue")
  },
  {
    name: "messages-following-feed",
    path: "/messages/following-feed",
    meta: following_45feedq6bFsX8jeNMeta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/messages/following-feed.vue")
  },
  {
    name: "messages-notifications-preferences",
    path: "/messages/notifications-preferences",
    meta: notifications_45preferences16klhIIRc4Meta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/messages/notifications-preferences.vue")
  },
  {
    name: "messages-replies-mentions",
    path: "/messages/replies-mentions",
    meta: replies_45mentionsqZ4gbYUxD0Meta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/messages/replies-mentions.vue")
  },
  {
    name: "messages-system-notifications",
    path: "/messages/system-notifications",
    meta: system_45notificationsM7D5wXw8OEMeta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/messages/system-notifications.vue")
  },
  {
    name: "models-model_id",
    path: "/models/:model_id()",
    meta: _91model_id_93pUNUxZmUYKMeta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/models/[model_id].vue")
  },
  {
    name: "models",
    path: "/models",
    meta: indexDottY4wqy9Meta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/models/index.vue")
  },
  {
    name: "models-third-party-model_id",
    path: "/models/third-party/:model_id()",
    meta: _91model_id_93qT49N82JMEMeta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/models/third-party/[model_id].vue")
  },
  {
    name: "search-collections",
    path: "/search/collections",
    meta: collectionsj5k5JjEntMMeta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/search/collections.vue")
  },
  {
    name: "search-creators",
    path: "/search/creators",
    meta: creatorsHVtxigTIATMeta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/search/creators.vue")
  },
  {
    name: "search-works",
    path: "/search/works",
    meta: works66GbGZo9dFMeta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/search/works.vue")
  },
  {
    name: "terms-pathName",
    path: "/terms/:pathName()",
    meta: _91pathName_937KKRD7AWFsMeta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/terms/[pathName].vue")
  },
  {
    name: "upload",
    path: "/upload",
    meta: indexsYkUOICUYJMeta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/upload/index.vue")
  },
  {
    name: "uploadPrintConf-model_id",
    path: "/uploadPrintConf/:model_id()",
    meta: _91model_id_937i9hPvjmUPMeta || {},
    component: () => import("/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/pages/uploadPrintConf/[model_id].vue")
  }
]